import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import { LIST_MEDIA_AGENT_BOOKINGS_QUERY_KEY } from '@/state/queries/media-agent-admin/use-list-media-agent-bookings';
import { LIST_MEDIA_AGENT_POOL_QUERY_KEY } from '@/state/queries/media-agent-admin/use-list-media-agent-pool';
import { PLATFORM_SUMMARY_QUERY_KEY } from '@/state/queries/ops-admin/use-platform-summary';
import { ATTENTION_QUEUE_QUERY_KEY } from '@/state/queries/ops-admin/use-attention-queue';

export function useResetMediaAgentBookingMutation() {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (bookingId: string) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/media-agent/bookings/${bookingId}/reset`;
      return sendJSONRequest({
        url,
        method: METHOD.POST,
        token: token ?? undefined,
      }) as Promise<{ bookingId: string; status: string }>;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [LIST_MEDIA_AGENT_BOOKINGS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [LIST_MEDIA_AGENT_POOL_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [PLATFORM_SUMMARY_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [ATTENTION_QUEUE_QUERY_KEY] });
    },
  });
}
